
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("fzRTW", function(module, exports) {

$parcel$export(module.exports, "register", () => $b573ef97cec72009$export$6503ec6e8aabbaf, (v) => $b573ef97cec72009$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $b573ef97cec72009$export$f7ad0328861e2f03, (v) => $b573ef97cec72009$export$f7ad0328861e2f03 = v);
var $b573ef97cec72009$export$6503ec6e8aabbaf;
var $b573ef97cec72009$export$f7ad0328861e2f03;
"use strict";
var $b573ef97cec72009$var$mapping = new Map();
function $b573ef97cec72009$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$b573ef97cec72009$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $b573ef97cec72009$var$resolve(id) {
    var resolved = $b573ef97cec72009$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$b573ef97cec72009$export$6503ec6e8aabbaf = $b573ef97cec72009$var$register;
$b573ef97cec72009$export$f7ad0328861e2f03 = $b573ef97cec72009$var$resolve;

});

parcelRegister("7ShCl", function(module, exports) {

$parcel$export(module.exports, "aiMessages", () => $3d55d2ba43147efd$export$480e55f805d7990f);

var $2nPZH = parcelRequire("2nPZH");
const $3d55d2ba43147efd$export$480e55f805d7990f = (0, $2nPZH.defineMessages)({
    // Event hub messages
    eventHubfallbackSuggestedTitle: {
        id: "fabric.editor.ai.eventHub.fallbackSuggestedTitle",
        defaultMessage: "Page title"
    },
    eventHubfallbackSuggestedTitlePrefix: {
        id: "fabric.editor.ai.eventHub.fallbackSuggestedTitlePrefix",
        defaultMessage: "Page"
    },
    // Toolbar messages
    aiToolbarTitle: {
        id: "fabric.editor.ai.toolbar.titleText",
        defaultMessage: "Atlassian Intelligence"
    },
    improveWritingToolbarIconTitle: {
        id: "fabric.editor.ai.toolbar.improveWriting.title",
        defaultMessage: "Improve writing"
    },
    improveWritingToolbarIconTooltip: {
        id: "fabric.editor.ai.toolbar.improveWriting.tooltip",
        defaultMessage: "Tell Atlassian Intelligence to improve the writing of your selection"
    },
    askAIToolbarIconTitle: {
        id: "fabric.editor.ai.toolbar.askAI.title",
        defaultMessage: "Ask AI"
    },
    askAIToolbarIconTooltip: {
        id: "fabric.editor.ai.toolbar.tryAI.tooltip",
        defaultMessage: "Open Atlassian Intelligence"
    },
    askAIToolbarIconTooltipQuickCommand: {
        id: "fabric.editor.ai.toolbar.tryAI.tooltip.quickCommand",
        defaultMessage: "Ask AI {key}+'"
    },
    tryAIToolbarIconTitle: {
        id: "fabric.editor.ai.toolbar.tryAI.title",
        defaultMessage: "Try AI"
    },
    tryAIToolbarIconTooltip: {
        id: "fabric.editor.ai.toolbar.tryAI.tooltip",
        defaultMessage: "Open Atlassian Intelligence"
    },
    simplifiedAIToolbarIconTitle: {
        id: "fabric.editor.ai.toolbar.simplifiedAI.title",
        defaultMessage: "AI"
    },
    // Prebuilt messages
    atlasGenerateContentConfigItemDescription: {
        id: "fabric.editor.ai.atlas-prebuilt.atlasGenerateContentConfigItemDescription",
        defaultMessage: "Generates content to be inserted into the update"
    },
    atlasSummarizePageConfigItemDescription: {
        id: "fabric.editor.ai.atlas-prebuilt.atlasSummarizePageConfigItemDescription",
        defaultMessage: "Summarizes the content of the update"
    },
    confluenceChangeToneSelectionToolbarDropdownMenuTitle: {
        id: "fabric.editor.ai.confluence-prebuilt.confluenceChangeToneSelectionToolbarDropdownMenuTitle",
        defaultMessage: "Change tone"
    },
    confluenceRewriteSelectionToolbarDropdownMenuTitle: {
        id: "fabric.editor.ai.confluence-prebuilt.confluenceRewriteSelectionToolbarDropdownMenuTitle",
        defaultMessage: "Rewrite"
    },
    confluenceTranslateSelectionToolbarDropdownMenuTitle: {
        id: "fabric.editor.ai.confluence-prebuilt.confluenceTranslateSelectionToolbarDropdownMenuTitle",
        defaultMessage: "Translate"
    },
    // AI Panel Action items messages
    actionItemsPageTitle: {
        id: "fabric.editor.ai.ai-panels.actionItemsPageTitle",
        defaultMessage: "Action items panel (Beta)"
    },
    actionItemsPageDescription: {
        id: "fabric.editor.ai.ai-panels.actionItemsPageDescription",
        defaultMessage: "Use Atlassian Intelligence to find action items and display in a panel"
    },
    // AI Panel Summarise page messages
    summarizePageTitle: {
        id: "fabric.editor.ai.ai-panels.summarizePageTitle",
        defaultMessage: "Page summary panel (Beta)"
    },
    summarisePageDescription: {
        id: "fabric.editor.ai.ai-panels.summarizePageDescription",
        defaultMessage: "Use Atlassian Intelligence to summarize this page and display in a panel"
    },
    // Agent messages
    agentsDropdownTitle: {
        id: "rovo.agents.dropdown.title",
        defaultMessage: "Agents"
    },
    agentsViewAgentsLabel: {
        id: "rovo.agents.dropdown.viewAgents.label",
        defaultMessage: "View all agents"
    },
    // Error messages
    unhandledErrorMessage: {
        id: "fabric.editor.ai.experience-application.unhandledErrorMessage",
        defaultMessage: "We're having trouble. Close the dialog and try again."
    },
    markdownErrorMessage: {
        id: "fabric.editor.ai.experience-application.error-boundary.markdownErrorMessage",
        defaultMessage: "We're having trouble generating the preview. Close the dialog and try again."
    },
    // Prompt Builder messages
    promptbuilderAriaLabel: {
        id: "fabric.editor.ai.commandPalette.promptBuilderForm.generateContent.ariaLabel",
        defaultMessage: "Ask Atlassian Intelligence"
    },
    promptBuilderFromButton: {
        id: "fabric.editor.ai.commandPalette.promptBuilderForm.buttons.submit",
        defaultMessage: "Generate"
    },
    // AI Smart button messages
    aiSmartButtonDynamicSurfaceSelectedContent: {
        id: "fabric.editor.ai.ai-smart-button.context.reference",
        defaultMessage: "Selected content"
    }
});

});

parcelRegister("2igSQ", function(module, exports) {

$parcel$export(module.exports, "TemplateVariableInput", () => $f852cc0c808326c8$export$cdee65ffaf9b2fb7);

var $gwFzn = parcelRequire("gwFzn");

var $fb3kw = parcelRequire("fb3kw");

var $2xdp1 = parcelRequire("2xdp1");

var $kwjRd = parcelRequire("kwjRd");

var $idCCS = parcelRequire("idCCS");
const $f852cc0c808326c8$export$cdee65ffaf9b2fb7 = ({ parameters: parameters })=>{
    // https://github.com/final-form/react-final-form/issues/103
    // If users name variables using numbers it breaks the form
    // hacky fix added a $ character in front
    const inputName = `$${parameters?.name}`;
    const inputPlaceholder = `${parameters?.placeholder || parameters?.name}`;
    // . [ or ] in the variable name causes Final Form to throw an error
    const validInputName = inputName.replace(/[`.\[\]\/]/gi, '');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kwjRd.TemplateVariableInputWrapper), null, parameters?.type === (0, $2xdp1.MULTI_LINES_TYPE) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kwjRd.TemplateVariableTextareaInputFieldWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        style: {
            display: 'inline-block',
            width: '100%'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $fb3kw.default), {
        name: validInputName,
        defaultValue: ""
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $idCCS.TemplateVariableInputComponent), {
            ...fieldProps,
            parameters: parameters,
            inputName: validInputName,
            placeholder: inputPlaceholder
        })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kwjRd.TemplateVariableInputFieldWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'inline-block',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: '100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            margin: '0px 0px'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $fb3kw.default), {
        name: validInputName,
        defaultValue: ""
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $idCCS.TemplateVariableInputComponent), {
            ...fieldProps,
            parameters: parameters,
            inputName: validInputName,
            placeholder: inputPlaceholder
        })))));
};

});
parcelRegister("2xdp1", function(module, exports) {

$parcel$export(module.exports, "defaultVariableName", () => $df54c7f294e74661$export$178c63c1bbc65458);
$parcel$export(module.exports, "TEXT_TYPE", () => $df54c7f294e74661$export$ae3b897442224943);
$parcel$export(module.exports, "MULTI_LINES_TYPE", () => $df54c7f294e74661$export$a43e313f04be91d7);
$parcel$export(module.exports, "LIST_TYPE", () => $df54c7f294e74661$export$22c50a44ec8aa5dd);
$parcel$export(module.exports, "ROWS_DEFAULT", () => $df54c7f294e74661$export$d1952e7dbe0fefc9);
$parcel$export(module.exports, "COLUMNS_DEFAULT", () => $df54c7f294e74661$export$777b44f8413b254e);

var $55ggG = parcelRequire("55ggG");
const $df54c7f294e74661$export$178c63c1bbc65458 = (0, $55ggG.i18n).templateVariableDefault.defaultMessage;
const $df54c7f294e74661$export$ae3b897442224943 = 'text';
const $df54c7f294e74661$export$a43e313f04be91d7 = 'textarea';
const $df54c7f294e74661$export$22c50a44ec8aa5dd = 'select';
const $df54c7f294e74661$export$d1952e7dbe0fefc9 = 5;
const $df54c7f294e74661$export$777b44f8413b254e = 100;

});
parcelRegister("55ggG", function(module, exports) {

$parcel$export(module.exports, "i18n", () => $446fbea06bd2a31f$export$a7357cdd1f0b0168);

var $2nPZH = parcelRequire("2nPZH");
const $446fbea06bd2a31f$export$a7357cdd1f0b0168 = (0, $2nPZH.defineMessages)({
    propertyPanelVariableDisplayString: {
        id: "template-variable.property.panel.variable.display.string",
        defaultMessage: "Text"
    },
    propertyPanelVariableDisplayStringTooltip: {
        id: "template-variable.property.panel.variable.display.string.tooltip",
        defaultMessage: "Single line text input field."
    },
    propertyPanelVariableDisplayTextArea: {
        id: "template-variable.property.panel.variable.display.textarea",
        defaultMessage: "Multi-line Text"
    },
    propertyPanelVariableDisplayTextAreaTooltip: {
        id: "template-variable.property.panel.variable.display.textarea.tooltip",
        defaultMessage: "Multi-line text input field."
    },
    propertyPanelVariableDisplayList: {
        id: "template-variable.property.panel.variable.display.list",
        defaultMessage: "List"
    },
    propertyPanelVariableDisplayListTooltip: {
        id: "template-variable.property.panel.variable.display.list.tooltip",
        defaultMessage: "Drop down list."
    },
    templateEditorChangingVariableDialogTitle: {
        id: "template-variable.template.editor.changing.variable.dialog.title",
        defaultMessage: "Edit template variable"
    },
    templateEditorVariableNameField: {
        id: "template-variable.template.editor.variable.name.field",
        defaultMessage: "Variable name"
    },
    propertyPanelVariableDisplayTextAreaRowsTooltip: {
        id: "template-variable.property.panel.variable.textarea.rows.tooltip",
        defaultMessage: "Number of rows to display for the field."
    },
    propertyPanelVariableDisplayTextAreaColumnsTooltip: {
        id: "template-variable.property.panel.variable.textarea.columns.tooltip",
        defaultMessage: "Number of columns to display for the field."
    },
    propertyPanelVariableListValuesTooltip: {
        id: "template-variable.property.panel.variable.list.values.tooltip",
        defaultMessage: "Enter each item for the list, separating each with a comma."
    },
    templateEditorVariableListFieldPlaceholder: {
        id: "template-variable.template.editor.variable.list.field.placeholder",
        defaultMessage: "option 1, option 2, option 3"
    },
    templateEditorVariableSaveButtonLabel: {
        id: "template-variable.template.editor.variable.save.button.label",
        defaultMessage: "Save"
    },
    templateVariableDefault: {
        id: "template-variable.template.editor.variable.name.default",
        defaultMessage: "variable_name"
    }
});

});


parcelRegister("kwjRd", function(module, exports) {

$parcel$export(module.exports, "TemplateVariableInputWrapper", () => $f809923cf8cfa046$export$4af78215734bfe2b);
$parcel$export(module.exports, "TemplateVariableNameWrapper", () => $f809923cf8cfa046$export$59d0bfd82baefce0);
$parcel$export(module.exports, "TemplateVariableName", () => $f809923cf8cfa046$export$8eff3c6bf5b8c758);
$parcel$export(module.exports, "TemplateVariableType", () => $f809923cf8cfa046$export$b4ff36272a61159f);
$parcel$export(module.exports, "TemplateVariableInputFieldWrapper", () => $f809923cf8cfa046$export$e3cad7a6d45ce703);
$parcel$export(module.exports, "TemplateVariableTextareaInputFieldWrapper", () => $f809923cf8cfa046$export$e9df20cb66227872);
$parcel$export(module.exports, "ButtonStyle", () => $f809923cf8cfa046$export$bdc3c19374266b98);
$parcel$export(module.exports, "DropDownInputWrapper", () => $f809923cf8cfa046$export$c996e1cc40266f34);
/* SharedComponents.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");
const $f809923cf8cfa046$export$4af78215734bfe2b = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $gwFzn.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_19pkxmi2 _otyrpxbi _n3tdv77o _1e0c1o8l",
            __cmplp.className
        ])
    });
});
const $f809923cf8cfa046$export$59d0bfd82baefce0 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $gwFzn.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1yt41e2s _2rkog0na _bfhkavxe",
            __cmplp.className
        ])
    });
});
const $f809923cf8cfa046$export$8eff3c6bf5b8c758 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $gwFzn.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1nmz9jpi _syaz1fxt _k48p4jg8",
            __cmplp.className
        ])
    });
});
const $f809923cf8cfa046$export$b4ff36272a61159f = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $gwFzn.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1yt41e2s _2rko1wxp _syaz131l _bfhkavxe _1nmz9jpi",
            __cmplp.className
        ])
    });
});
const $f809923cf8cfa046$export$e3cad7a6d45ce703 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $gwFzn.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1e0c1o8l _p12f1osq _o5724jg8",
            __cmplp.className
        ])
    });
});
const $f809923cf8cfa046$export$e9df20cb66227872 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $gwFzn.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1e0c1o8l _p12f1osq _kqswh2mm _s7n4jp4b",
            __cmplp.className
        ])
    });
});
const $f809923cf8cfa046$export$bdc3c19374266b98 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $gwFzn.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_vr2wn7od",
            __cmplp.className
        ])
    });
});
const $f809923cf8cfa046$export$c996e1cc40266f34 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $gwFzn.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_18u0v77o",
            __cmplp.className
        ])
    });
});

});

parcelRegister("idCCS", function(module, exports) {

$parcel$export(module.exports, "TemplateVariableInputComponent", () => $ab3c5e793706abd9$export$f57c870ff73570c7);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $ghftu = parcelRequire("ghftu");

var $9EtP6 = parcelRequire("9EtP6");

var $4noo5 = parcelRequire("4noo5");

var $cuAuQ = parcelRequire("cuAuQ");

var $4KS7f = parcelRequire("4KS7f");

var $3gadb = parcelRequire("3gadb");

var $kwjRd = parcelRequire("kwjRd");

var $2xdp1 = parcelRequire("2xdp1");
const $ab3c5e793706abd9$export$a7357cdd1f0b0168 = (0, $2nPZH.defineMessages)({
    invalidVariableNameError: {
        id: "template-variable.description.invalid.variable.name",
        defaultMessage: "This template contains a variable using invalid character(s) (. , [ , ], /). Please have the template owner remove these characters from the variable to use it."
    }
});
const $ab3c5e793706abd9$var$generateDropdownOptionsList = (options)=>options ? options.map((option)=>({
            label: option,
            value: option
        })) : [];
const $ab3c5e793706abd9$var$styles = {
    option: (provided)=>({
            ...provided,
            wordBreak: 'break-word'
        })
};
const $ab3c5e793706abd9$var$checkTemplateVariableValidity = (variableName)=>{
    const invalidVariableCharacters = [
        '.',
        '[',
        ']',
        '/'
    ];
    return invalidVariableCharacters.some((invalidVariableCharacter)=>variableName?.includes(invalidVariableCharacter));
};
const $ab3c5e793706abd9$export$25a5c8174bd010d5 = ({ parameters: parameters, onChange: onChange, value: value, placeholder: placeholder })=>{
    const intl = (0, $dBxQj.default)();
    // We are passing in placeholder as the validity check b/c it hasn't been stripped of . [ or ]
    const hasInvalidVariableName = $ab3c5e793706abd9$var$checkTemplateVariableValidity(placeholder);
    const parameterOptions = parameters.params && parameters.params.options;
    const options = (0, $gwFzn.useMemo)(()=>$ab3c5e793706abd9$var$generateDropdownOptionsList(parameterOptions), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        parameterOptions
    ]);
    const onChangeHandler = (0, $gwFzn.useMemo)(()=>(option)=>{
            onChange(option.value);
        }, [
        onChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, hasInvalidVariableName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3gadb.default), {
        content: intl.formatMessage($ab3c5e793706abd9$export$a7357cdd1f0b0168.invalidVariableNameError)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kwjRd.DropDownInputWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $cuAuQ.default), {
        options: options,
        placeholder: `${value || placeholder}`,
        onChange: onChangeHandler,
        target: ({ ref: ref, isOpen: isOpen })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kwjRd.ButtonStyle), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4KS7f.default), {
                ref: ref,
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                    label: "dropdown icon",
                    size: "small"
                }),
                isSelected: isOpen,
                isDisabled: hasInvalidVariableName
            }, `${value || placeholder}`)),
        popperProps: {
            placement: 'auto',
            modifiers: [
                {
                    name: 'preventOverflow',
                    options: {
                        boundary: 'clippingParents'
                    }
                }
            ]
        },
        maxMenuHeight: 200,
        maxMenuWidth: 200,
        searchThreshold: 10,
        styles: $ab3c5e793706abd9$var$styles,
        value: {
            label: value,
            value: value
        }
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kwjRd.DropDownInputWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $cuAuQ.default), {
        options: options,
        placeholder: `${value || placeholder}`,
        onChange: onChangeHandler,
        target: ({ ref: ref, isOpen: isOpen })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kwjRd.ButtonStyle), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4KS7f.default), {
                ref: ref,
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                    label: "dropdown icon",
                    size: "small"
                }),
                isSelected: isOpen,
                isDisabled: parameters.isDisabled
            }, `${value || placeholder}`)),
        popperProps: {
            placement: 'auto',
            modifiers: [
                {
                    name: 'preventOverflow',
                    options: {
                        boundary: 'clippingParents'
                    }
                }
            ]
        },
        maxMenuHeight: 200,
        maxMenuWidth: 200,
        searchThreshold: 10,
        styles: $ab3c5e793706abd9$var$styles,
        value: {
            label: value,
            value: value
        }
    })));
};
const $ab3c5e793706abd9$export$b9055edfa32ac8b4 = ({ onChange: onChange, value: value, inputName: inputName, parameters: parameters, placeholder: placeholder })=>{
    const intl = (0, $dBxQj.default)();
    // We are passing in placeholder as the validity check b/c it hasn't been stripped of . [ or ]
    const hasInvalidVariableName = $ab3c5e793706abd9$var$checkTemplateVariableValidity(placeholder);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, hasInvalidVariableName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3gadb.default), {
        content: intl.formatMessage($ab3c5e793706abd9$export$a7357cdd1f0b0168.invalidVariableNameError)
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4noo5.default), {
            ...tooltipProps,
            testId: "text-field-input",
            name: inputName,
            onChange: onChange,
            value: value || '',
            placeholder: placeholder,
            isDisabled: hasInvalidVariableName,
            width: 200,
            isCompact: true
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4noo5.default), {
        testId: "text-field-input",
        name: inputName,
        onChange: onChange,
        value: value || '',
        placeholder: placeholder,
        isDisabled: parameters?.isDisabled,
        width: 200,
        isCompact: true
    }));
};
const $ab3c5e793706abd9$export$9a5caaaacb4c92d3 = ({ parameters: parameters, onChange: onChange, value: value, placeholder: placeholder })=>{
    const intl = (0, $dBxQj.default)();
    // We are passing in placeholder as the validity check b/c it hasn't been stripped of . [ or ]
    const hasInvalidVariableName = $ab3c5e793706abd9$var$checkTemplateVariableValidity(placeholder);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, hasInvalidVariableName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3gadb.default), {
        content: intl.formatMessage($ab3c5e793706abd9$export$a7357cdd1f0b0168.invalidVariableNameError)
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9EtP6.default), {
            ...tooltipProps,
            testId: "text-area-input",
            onChange: onChange,
            value: value || '',
            minimumRows: parameters.params && parameters.params.rows || 1,
            // @ts-ignore cols used to be in the list of props of TextArea but later then removed
            cols: parameters.params && parameters.params.columns || 30,
            resize: "vertical",
            isDisabled: hasInvalidVariableName,
            placeholder: placeholder
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9EtP6.default), {
        testId: "text-area-input",
        onChange: onChange,
        value: value || '',
        minimumRows: parameters.params && parameters.params.rows || 1,
        // @ts-ignore cols used to be in the list of props of TextArea but later then removed
        cols: parameters.params && parameters.params.columns || 30,
        resize: "vertical",
        isDisabled: parameters?.isDisabled,
        placeholder: placeholder
    }));
};
const $ab3c5e793706abd9$export$f57c870ff73570c7 = (props)=>{
    const { parameters: parameters } = props;
    switch(parameters.type){
        case 0, $2xdp1.LIST_TYPE:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($ab3c5e793706abd9$export$25a5c8174bd010d5, props);
        case 0, $2xdp1.MULTI_LINES_TYPE:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($ab3c5e793706abd9$export$9a5caaaacb4c92d3, props);
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($ab3c5e793706abd9$export$b9055edfa32ac8b4, props);
    }
};

});


parcelRegister("jn9ek", function(module, exports) {

$parcel$export(module.exports, "isBadThirdPartyBlueprintError", () => $2f7d9ade7a6b90fb$export$9ae592643c1ef19b);
$parcel$export(module.exports, "isBadEditedFirstPartyBlueprintError", () => $2f7d9ade7a6b90fb$export$af33641014b57bba);
$parcel$export(module.exports, "isInvalidSpaceKeyError", () => $2f7d9ade7a6b90fb$export$b6b21a057779c53b);
$parcel$export(module.exports, "isRateExceededError", () => $2f7d9ade7a6b90fb$export$66b6e2f5ed3b8e08);
$parcel$export(module.exports, "getTraceIdFromApolloError", () => $2f7d9ade7a6b90fb$export$69408b85ed2a0e77);
const $2f7d9ade7a6b90fb$var$_isBadThirdPartyBlueprintError = (error)=>{
    const { originalError: originalError } = error;
    return String(originalError?.message) === 'third party blueprint has an error' && String(originalError?.response?.status) === '500';
};
const $2f7d9ade7a6b90fb$var$_isBadEditedFirstPartyBlueprintError = (error)=>{
    const { originalError: originalError } = error;
    return String(originalError?.message) === 'Edited 1st party blueprint has an error' && String(originalError?.response?.status) === '500';
};
const $2f7d9ade7a6b90fb$var$_isInvalidSpaceKeyError = (error)=>{
    const { originalError: originalError } = error;
    return String(originalError?.message) === 'Content created or updated with invalid arguments: Invalid space key specified.' && String(originalError?.response?.status) === '500';
};
const $2f7d9ade7a6b90fb$var$_isExceededRateError = (error)=>{
    const { originalError: originalError } = error;
    return String(originalError?.message).includes('rate limit exceeded');
};
const $2f7d9ade7a6b90fb$export$9ae592643c1ef19b = (error)=>{
    return !!error?.graphQLErrors?.some($2f7d9ade7a6b90fb$var$_isBadThirdPartyBlueprintError);
};
const $2f7d9ade7a6b90fb$export$af33641014b57bba = (error)=>{
    return !!error?.graphQLErrors?.some($2f7d9ade7a6b90fb$var$_isBadEditedFirstPartyBlueprintError);
};
const $2f7d9ade7a6b90fb$export$b6b21a057779c53b = (error)=>{
    return !!error?.graphQLErrors?.some($2f7d9ade7a6b90fb$var$_isInvalidSpaceKeyError);
};
const $2f7d9ade7a6b90fb$export$66b6e2f5ed3b8e08 = (error)=>{
    return !!error?.graphQLErrors?.some($2f7d9ade7a6b90fb$var$_isExceededRateError);
};
const $2f7d9ade7a6b90fb$export$69408b85ed2a0e77 = (error)=>{
    if (error && 'graphQLErrors' in error) {
        const originalError = error.graphQLErrors?.[0]?.originalError;
        return originalError?.traceId || '';
    }
    return '';
};

});

parcelRegister("2HGN8", function(module, exports) {

$parcel$export(module.exports, "ContentAppearanceContextProvider", () => $652df36b21c46ede$export$53c04435be7a0acf);
$parcel$export(module.exports, "ContentAppearanceContextConsumer", () => $652df36b21c46ede$export$c3c73be39a08fc97);
$parcel$export(module.exports, "useContentAppearance", () => $652df36b21c46ede$export$4cedbdf2fdf3340d);

var $gwFzn = parcelRequire("gwFzn");

var $j1Ss3 = parcelRequire("j1Ss3");

var $jXpbL = parcelRequire("jXpbL");

var $8VcPj = parcelRequire("8VcPj");

var $CTedk = parcelRequire("CTedk");
const $652df36b21c46ede$var$ContentAppearanceContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createContext({
    contentAppearance: {
        appearance: (0, $CTedk.ContentAppearanceType).DEFAULT,
        version: 0
    },
    setContentAppearance: ()=>{},
    contentAppearanceLoading: false
});
const $652df36b21c46ede$export$53c04435be7a0acf = ({ contentId: contentId, children: children })=>{
    const [contentAppearanceOverride, setContentAppearanceOverride] = (0, $gwFzn.useState)();
    const [{ collabEditProvider: collabEditProvider }] = (0, $jXpbL.useNativeCollabState)();
    // Subscribe to metadata:changed events to update the content appearance for collaborators
    (0, $gwFzn.useEffect)(()=>{
        if (!collabEditProvider) return;
        const handleMetadataChanged = (metadata)=>{
            const widthValue = metadata?.editorWidth?.value;
            const version = metadata?.editorWidth?.version;
            if (widthValue) setContentAppearanceOverride((currentAppearance)=>{
                if (!currentAppearance || version > currentAppearance.version) return {
                    appearance: widthValue,
                    version: version
                };
                else return currentAppearance;
            });
        };
        collabEditProvider.on('metadata:changed', handleMetadataChanged);
        return ()=>{
            collabEditProvider.off('metadata:changed', handleMetadataChanged);
        };
    }, [
        collabEditProvider
    ]);
    const draftAppearanceQuery = (0, $8VcPj.getContentAppearanceQuery)((0, $CTedk.ContentAppearancePropertyKey).DRAFT);
    const { data: initialContentAppearanceData, loading: initialContentAppearanceLoading } = (0, $j1Ss3.useQuery)(draftAppearanceQuery, {
        variables: {
            contentId: contentId,
            status: [
                'current',
                'draft'
            ]
        }
    });
    const context = (0, $gwFzn.useMemo)(()=>{
        const initialContentAppearance = (0, $8VcPj.getContentAppearanceFromQueryData)(initialContentAppearanceData, (0, $CTedk.ContentAppearancePropertyKey).DRAFT);
        return {
            contentAppearance: contentAppearanceOverride || initialContentAppearance,
            setContentAppearance: setContentAppearanceOverride,
            contentAppearanceLoading: initialContentAppearanceLoading
        };
    }, [
        initialContentAppearanceData,
        initialContentAppearanceLoading,
        contentAppearanceOverride
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($652df36b21c46ede$var$ContentAppearanceContext.Provider, {
        value: context
    }, children);
};
const $652df36b21c46ede$export$c3c73be39a08fc97 = ({ children: children })=>{
    const context = $652df36b21c46ede$export$4cedbdf2fdf3340d();
    return children(context);
};
const $652df36b21c46ede$export$4cedbdf2fdf3340d = ()=>{
    return (0, $gwFzn.useContext)($652df36b21c46ede$var$ContentAppearanceContext);
};

});

parcelRegister("5un3P", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_DYNAMIC_CARDS_COUNT", () => $a247ba2e22f9ecac$export$12c9c8946ce83b13);
$parcel$export(module.exports, "DEFAULT_CARDS_SIZE", () => $a247ba2e22f9ecac$export$eea11e2ee6ebb03f);
$parcel$export(module.exports, "Orientation", () => $a247ba2e22f9ecac$export$df54d73aa0ec5e82);
$parcel$export(module.exports, "Alignment", () => $a247ba2e22f9ecac$export$9d7927214ed7d2cf);
$parcel$export(module.exports, "ImagePosition", () => $a247ba2e22f9ecac$export$a1ccd8e6c4b447b2);
$parcel$export(module.exports, "CardsLayout", () => $a247ba2e22f9ecac$export$9eefe1d63a5bbb7e);
$parcel$export(module.exports, "CardSize", () => (parcelRequire("4cOi8")).Height);

var $4cOi8 = parcelRequire("4cOi8");
const $a247ba2e22f9ecac$export$12c9c8946ce83b13 = 3;
const $a247ba2e22f9ecac$export$eea11e2ee6ebb03f = (0, $4cOi8.Height).MEDIUM;
var $a247ba2e22f9ecac$export$df54d73aa0ec5e82 = /*#__PURE__*/ function(Orientation) {
    Orientation["ROW"] = "row";
    Orientation["STACKED"] = "stacked";
    return Orientation;
}({});
var $a247ba2e22f9ecac$export$9d7927214ed7d2cf = /*#__PURE__*/ function(Alignment) {
    Alignment["LEFT"] = "left";
    Alignment["CENTER"] = "center";
    Alignment["RIGHT"] = "right";
    return Alignment;
}({});
var $a247ba2e22f9ecac$export$a1ccd8e6c4b447b2 = /*#__PURE__*/ function(ImagePosition) {
    ImagePosition["TOP"] = "top";
    ImagePosition["MIDDLE"] = "middle";
    ImagePosition["BOTTOM"] = "bottom";
    return ImagePosition;
}({});
var $a247ba2e22f9ecac$export$9eefe1d63a5bbb7e = /*#__PURE__*/ function(CardsLayout) {
    CardsLayout["FIXED_IMAGE_HEIGHT"] = "fixed-image-height";
    CardsLayout["FLEXIBLE_IMAGE_HEIGHT"] = "flexible-image-height";
    return CardsLayout;
}({});

});

parcelRegister("2vQcO", function(module, exports) {

$parcel$export(module.exports, "createCard", () => $d021ca2ceb8d1f69$export$b7316deff43c35f7);
$parcel$export(module.exports, "getDefaultCards", () => $d021ca2ceb8d1f69$export$adc082ec96ce9cca);
$parcel$export(module.exports, "linkCardsParameters", () => $d021ca2ceb8d1f69$export$c06a31b1c63a03bb);
$parcel$export(module.exports, "linkCardsExtensionProvider", () => $d021ca2ceb8d1f69$export$7405c372b05d8ba8);

var $gwFzn = parcelRequire("gwFzn");

var $kyKWe = parcelRequire("kyKWe");

var $2nPZH = parcelRequire("2nPZH");

var $bre0g = parcelRequire("bre0g");

var $dh538 = parcelRequire("dh538");

var $5un3P = parcelRequire("5un3P");
var $kcoxM = parcelRequire("kcoxM");

var $ekK2d = parcelRequire("ekK2d");

var $jmjWc = parcelRequire("jmjWc");

const $d021ca2ceb8d1f69$var$LinkCardsExtension = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "pe96n",
    name: "LinkCardsExtension",
    loader: async ()=>(await (parcelRequire("gB6nx"))).LinkCardsExtension
});
const $d021ca2ceb8d1f69$var$cardImages = [
    {
        src: 'https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?auto=format&fit=crop&q=80&w=1080',
        alt: 'green mountain across body of water'
    },
    {
        src: 'https://images.unsplash.com/photo-1501436513145-30f24e19fcc8?auto=format&fit=crop&q=80&w=1080',
        alt: 'calm body of water during golden hour'
    },
    {
        src: 'https://images.unsplash.com/photo-1580100586938-02822d99c4a8?auto=format&fit=crop&q=80&w=1080',
        alt: 'body of water near mountain during daytime'
    }
];
const $d021ca2ceb8d1f69$var$i18n = (0, $2nPZH.defineMessages)({
    linkCardsMacroTitle: {
        id: "custom-sites-extensions.link-cards.manifest.macro-title",
        defaultMessage: "Cards"
    },
    linkCardsMacroDescription: {
        id: "custom-sites-extensions.link-cards.manifest.macro-description",
        defaultMessage: "Display links as cards"
    }
});
const $d021ca2ceb8d1f69$export$b7316deff43c35f7 = (imageSrc, imageAltText)=>({
        cardId: (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))(),
        link: '',
        isLinkUserEdited: false,
        title: '',
        isTitleUserEdited: false,
        description: '',
        isDescriptionUserEdited: false,
        imageSrc: imageSrc,
        imagePosition: (0, $5un3P.ImagePosition).MIDDLE,
        imageAltText: imageAltText
    });
let $d021ca2ceb8d1f69$var$cards = null;
const $d021ca2ceb8d1f69$export$adc082ec96ce9cca = ()=>{
    if ($d021ca2ceb8d1f69$var$cards) return $d021ca2ceb8d1f69$var$cards;
    return $d021ca2ceb8d1f69$var$cards = $d021ca2ceb8d1f69$var$cardImages.map(({ src: src, alt: alt })=>$d021ca2ceb8d1f69$export$b7316deff43c35f7(src, alt));
};
const $d021ca2ceb8d1f69$export$c06a31b1c63a03bb = (extensionTitle, isAutoscrollGateEnabled, isVisualCardsConfigUpdatesEnabled)=>{
    var // default to false unless user already assigned autoscroll to enabled/disabled
    _parameters;
    const parameters = {
        size: (0, $5un3P.DEFAULT_CARDS_SIZE),
        cards: $d021ca2ceb8d1f69$export$adc082ec96ce9cca(),
        isAvatarShown: true,
        isPublishDateShown: false,
        extensionTitle: extensionTitle,
        version: (0, $kcoxM.CARDS_EXTENSION_VERSION_3),
        renderVariant: (0, $ekK2d.RenderVariant).MANUAL,
        isSegmentationShown: false,
        orientation: (0, $5un3P.Orientation).ROW,
        alignment: (0, $5un3P.Alignment).LEFT
    };
    if (isAutoscrollGateEnabled) (_parameters = parameters).isAutoscrollEnabled ?? (_parameters.isAutoscrollEnabled = false);
    if (isVisualCardsConfigUpdatesEnabled) parameters.backgroundColor = "var(--ds-surface, #FFFFFF)";
    return parameters;
};

const $d021ca2ceb8d1f69$export$d0035282aa5b6697 = ({ editorActions: editorActions, openConfigPanel: openConfigPanel, intl: intl, setUpsellModalSource: setUpsellModalSource, contentId: contentId })=>{
    return {
        title: intl.formatMessage($d021ca2ceb8d1f69$var$i18n.linkCardsMacroTitle),
        type: (0, $kcoxM.CARDS_EXTENSION_TYPE),
        key: (0, $kcoxM.CARDS_EXTENSION_KEY),
        description: intl.formatMessage($d021ca2ceb8d1f69$var$i18n.linkCardsMacroDescription),
        icons: {
            '48': ()=>(parcelRequire("iwcbL")).then((mod)=>mod.CardMacroIcon)
        },
        modules: {
            quickInsert: setUpsellModalSource ? [
                {
                    key: 'cards-upsell',
                    action: async ()=>setUpsellModalSource('premiumCardsInsert')
                }
            ] : [
                {
                    key: 'default-cards',
                    action: {
                        type: 'node',
                        key: 'default',
                        parameters: $d021ca2ceb8d1f69$export$c06a31b1c63a03bb(intl.formatMessage($d021ca2ceb8d1f69$var$i18n.linkCardsMacroTitle), (0, $dh538.fg)('company_hub_cards_autoscroll'), (0, $dh538.fg)('company_hub_cards_visual_update'))
                    }
                }
            ],
            nodes: {
                default: {
                    type: 'extension',
                    render: async ()=>({ node: node })=>{
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($d021ca2ceb8d1f69$var$LinkCardsExtension, {
                                extensionNode: node,
                                contentId: contentId
                            });
                        },
                    update: async ()=>{
                        const selectedNode = editorActions?.getSelectedNode()?.toJSON();
                        const selectedLocalId = selectedNode?.attrs?.localId;
                        if (!!selectedLocalId && openConfigPanel) openConfigPanel(selectedLocalId);
                    }
                }
            }
        }
    };
};
const $d021ca2ceb8d1f69$export$7405c372b05d8ba8 = async ({ contentId: contentId, editorActions: editorActions, openConfigPanel: openConfigPanel, intl: intl, setUpsellModalSource: setUpsellModalSource })=>new (0, $bre0g.default)([
        $d021ca2ceb8d1f69$export$d0035282aa5b6697({
            contentId: contentId,
            editorActions: editorActions,
            openConfigPanel: openConfigPanel,
            intl: intl,
            setUpsellModalSource: setUpsellModalSource
        })
    ]);

});
parcelRegister("ekK2d", function(module, exports) {

$parcel$export(module.exports, "ITEM_FIELDS", () => $8258c4c42c170e42$export$bf7ebf7fed6e7189);
$parcel$export(module.exports, "CONDITIONAL_FIELDS", () => $8258c4c42c170e42$export$63d216eda7dcfec9);
$parcel$export(module.exports, "RenderVariant", () => $8258c4c42c170e42$export$1f60141b6ce5efed);
$parcel$export(module.exports, "SegmentationTargets", () => $8258c4c42c170e42$export$f6cd408cac7f930c);
var $8258c4c42c170e42$export$bf7ebf7fed6e7189 = /*#__PURE__*/ function(ITEM_FIELDS) {
    ITEM_FIELDS["CARD_ID"] = "cardId";
    ITEM_FIELDS["TITLE"] = "title";
    ITEM_FIELDS["IS_TITLE_USER_EDITED"] = "isTitleUserEdited";
    ITEM_FIELDS["DESCRIPTION"] = "description";
    ITEM_FIELDS["IS_DESCRIPTION_USER_EDITED"] = "isDescriptionUserEdited";
    ITEM_FIELDS["LABEL"] = "label";
    ITEM_FIELDS["LINK"] = "link";
    ITEM_FIELDS["IS_LINK_USER_EDITED"] = "isLinkUserEdited";
    ITEM_FIELDS["IMAGE_SRC"] = "imageSrc";
    ITEM_FIELDS["CONFLUENCE_PAGE_ID"] = "confluencePageId";
    ITEM_FIELDS["IMAGE_ALT_TEXT"] = "imageAltText";
    ITEM_FIELDS["SEGMENTATION_TARGETS"] = "segmentationTarget";
    ITEM_FIELDS["AUDIENCE_SEGMENTATION_GROUP_IDS"] = "audienceSegmentationGroupIds";
    ITEM_FIELDS["LINK_RESOURCE_TYPE"] = "linkResourceType";
    ITEM_FIELDS["BACKGROUND_COLOR"] = "backgroundColor";
    ITEM_FIELDS["TEXT_COLOR"] = "textColor";
    ITEM_FIELDS["LAYOUT"] = "layout";
    ITEM_FIELDS["IS_BUTTON_SHOWN"] = "isButtonShown";
    ITEM_FIELDS["BUTTON_TEXT"] = "buttonText";
    ITEM_FIELDS["BUTTON_STYLE"] = "buttonStyle";
    ITEM_FIELDS["HEIGHT"] = "height";
    return ITEM_FIELDS;
}({});
var $8258c4c42c170e42$export$63d216eda7dcfec9 = /*#__PURE__*/ function(CONDITIONAL_FIELDS) {
    CONDITIONAL_FIELDS["IS_AVATAR_SHOWN"] = "isAvatarShown";
    CONDITIONAL_FIELDS["IS_PUBLISH_DATE_SHOWN"] = "isPublishDateShown";
    CONDITIONAL_FIELDS["IS_SEGMENTATION_SHOWN"] = "isSegmentationShown";
    return CONDITIONAL_FIELDS;
}({});
var $8258c4c42c170e42$export$1f60141b6ce5efed = /*#__PURE__*/ function(RenderVariant) {
    RenderVariant["MANUAL"] = "manual";
    RenderVariant["DYNAMIC"] = "dynamic";
    return RenderVariant;
}({});
var $8258c4c42c170e42$export$f6cd408cac7f930c = /*#__PURE__*/ function(SegmentationTargets) {
    SegmentationTargets["ALL"] = "all";
    SegmentationTargets["EACH"] = "each";
    return SegmentationTargets;
}({});

});

parcelRegister("gB6nx", function(module, exports) {

let $c1550cb865bfd5c6$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $c1550cb865bfd5c6$var$load("iOWBI"),
    $c1550cb865bfd5c6$var$load("5nZdp"),
    $c1550cb865bfd5c6$var$load("lRAA1"),
    $c1550cb865bfd5c6$var$load("8Sd4b"),
    $c1550cb865bfd5c6$var$load("joJy8"),
    $c1550cb865bfd5c6$var$load("aHE9G"),
    $c1550cb865bfd5c6$var$load("7jSfd"),
    $c1550cb865bfd5c6$var$load("4HZlX"),
    $c1550cb865bfd5c6$var$load("kDqHr"),
    $c1550cb865bfd5c6$var$load("kjZZD"),
    $c1550cb865bfd5c6$var$load("ffEVr"),
    $c1550cb865bfd5c6$var$load("bSMGI"),
    $c1550cb865bfd5c6$var$load("2pYvv")
]).then(()=>parcelRequire('jWHrX'));

});
parcelRegister("lhnSv", function(module, exports) {
"use strict";


let $f7ddb539c5788a9e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("9WHwv")).shardUrl((parcelRequire("fzRTW")).resolve(id), maxShards));
    };
module.exports = $f7ddb539c5788a9e$var$load;

});
parcelRegister("9WHwv", function(module, exports) {

$parcel$export(module.exports, "shardUrl", () => $73db4aabb0664d41$export$2bf9932c19d6a5d2, (v) => $73db4aabb0664d41$export$2bf9932c19d6a5d2 = v);
$parcel$export(module.exports, "domainShardingKey", () => $73db4aabb0664d41$export$f6f4188f9108e61, (v) => $73db4aabb0664d41$export$f6f4188f9108e61 = v);
// TODO: convert this file to ESM once HMR issues are resolved
var $73db4aabb0664d41$export$2bf9932c19d6a5d2;
var $73db4aabb0664d41$export$1d37a31d51d1e3ed;
var $73db4aabb0664d41$export$b4cd98d62f81485f;
var $73db4aabb0664d41$export$108ff8fc702e621f;
var $73db4aabb0664d41$export$f6f4188f9108e61;
"use strict";
let $73db4aabb0664d41$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 *
 * @param {string} pathname
 * @returns {string}
 */ function $73db4aabb0664d41$var$getFilenameFromUrlPath(pathname) {
    let lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 *
 * @param {string} str
 * @param {number} maxShards
 * @returns {number}
 */ function $73db4aabb0664d41$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    let totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        let n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
let $73db4aabb0664d41$var$trailingShardRegex = /-\d+$/;
/**
 * @param {string} subdomain
 */ function $73db4aabb0664d41$var$removeTrailingShard(subdomain) {
    if (!$73db4aabb0664d41$var$trailingShardRegex.test(subdomain)) return subdomain;
    let shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 *
 * @param {string} domain
 * @param {number} shard
 */ function $73db4aabb0664d41$var$applyShardToDomain(domain, shard) {
    let i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    let shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$73db4aabb0664d41$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    let firstSubdomain = $73db4aabb0664d41$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $73db4aabb0664d41$var$shardUrlUnchecked(url, maxShards) {
    let parsedUrl = new URL(url);
    let fileName = $73db4aabb0664d41$var$getFilenameFromUrlPath(parsedUrl.pathname);
    let shardNumber = $73db4aabb0664d41$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $73db4aabb0664d41$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $73db4aabb0664d41$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$73db4aabb0664d41$var$globalKeyName]) return url;
    return $73db4aabb0664d41$var$shardUrlUnchecked(url, maxShards);
}
$73db4aabb0664d41$export$2bf9932c19d6a5d2 = $73db4aabb0664d41$var$shardUrl;
$73db4aabb0664d41$export$1d37a31d51d1e3ed = $73db4aabb0664d41$var$shardUrlUnchecked;
$73db4aabb0664d41$export$b4cd98d62f81485f = $73db4aabb0664d41$var$getDomainShardIndex;
$73db4aabb0664d41$export$108ff8fc702e621f = $73db4aabb0664d41$var$applyShardToDomain;
$73db4aabb0664d41$export$f6f4188f9108e61 = $73db4aabb0664d41$var$globalKeyName;

});



parcelRegister("iwcbL", function(module, exports) {

let $d7b4ab960e89a375$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $d7b4ab960e89a375$var$load("8dyWu").then(()=>parcelRequire('e3FDi'));

});


parcelRegister("g3LxX", function(module, exports) {

$parcel$export(module.exports, "useExtensionsState", () => $753deba3fe656290$export$732cb2f7b629a11e);
$parcel$export(module.exports, "useExtensionsActions", () => $753deba3fe656290$export$d50cb813b9099554);

var $iFWZA = parcelRequire("iFWZA");
var $4ZoIm = parcelRequire("4ZoIm");
const $753deba3fe656290$var$initialState = {
    isInViewMode: true,
    isInAutoFocusMode: true,
    selectedExtensionLocalId: null,
    selectedToEditCardId: null,
    selectedToRemoveCardId: null
};
// Actions for managing the Custom Site Extensions state that is shared between the extension and the config panel
const $753deba3fe656290$var$actions = {
    setIsInViewMode: (isInViewMode)=>({ setState: setState })=>{
            setState({
                isInViewMode: isInViewMode
            });
        },
    setIsInAutoFocusMode: (isInAutoFocusMode)=>({ setState: setState })=>{
            setState({
                isInAutoFocusMode: isInAutoFocusMode
            });
        },
    setSelectedExtensionLocalId: (extensionLocalId)=>({ getState: getState, setState: setState })=>{
            if (getState().isInViewMode) return;
            setState({
                selectedExtensionLocalId: extensionLocalId
            });
        },
    setSelectedToEditCardId: (cardId)=>({ getState: getState, setState: setState })=>{
            if (getState().isInViewMode) return;
            setState({
                selectedToEditCardId: cardId
            });
        },
    setSelectedToRemoveCardId: (cardId)=>({ getState: getState, setState: setState })=>{
            if (getState().isInViewMode) return;
            setState({
                selectedToRemoveCardId: cardId
            });
        }
};
const $753deba3fe656290$var$ExtensionsStateStore = (0, $4ZoIm.createStore)({
    initialState: $753deba3fe656290$var$initialState,
    actions: $753deba3fe656290$var$actions,
    name: 'ExtensionsStateStore'
});
const $753deba3fe656290$export$732cb2f7b629a11e = (0, $iFWZA.createHook)($753deba3fe656290$var$ExtensionsStateStore);
const $753deba3fe656290$export$d50cb813b9099554 = (0, $iFWZA.createActionsHook)($753deba3fe656290$var$ExtensionsStateStore);

});

parcelRegister("1VNax", function(module, exports) {

$parcel$export(module.exports, "checkItems", () => $c0bf087c1d0f2640$export$3831ccf0db7ad748);
const $c0bf087c1d0f2640$var$validateItemsUrls = (items)=>{
    items.forEach((item)=>{
        if (!!item?.link && !item?.link.startsWith('http')) item.link = '';
    });
};
const $c0bf087c1d0f2640$export$3831ccf0db7ad748 = (items)=>{
    if (!items || items?.length === 0) return null;
    else if (Array.isArray(items)) {
        $c0bf087c1d0f2640$var$validateItemsUrls(items);
        return items;
    }
};

});

parcelRegister("7q60U", function(module, exports) {

$parcel$export(module.exports, "updateNodeParameters", () => $a5eaa64c2546cc45$export$9860c2f1456a166d);
$parcel$export(module.exports, "replaceSelectedNode", () => $a5eaa64c2546cc45$export$39874bca494f9ba3);
const $a5eaa64c2546cc45$export$9860c2f1456a166d = (editorActions, updatedParameters)=>{
    const selectedNodeJSON = editorActions.getSelectedNode()?.toJSON();
    const updatedNodeSelection = {
        ...selectedNodeJSON,
        attrs: {
            ...selectedNodeJSON?.attrs,
            parameters: {
                ...updatedParameters
            }
        }
    };
    editorActions.replaceSelection(updatedNodeSelection, true);
};
const $a5eaa64c2546cc45$export$39874bca494f9ba3 = (editorActions, nodeAdf)=>{
    editorActions.replaceSelection(nodeAdf, true);
};

});

parcelRegister("drkRB", function(module, exports) {

$parcel$export(module.exports, "NavigationStyle", () => $ee66395b0435b80e$export$f8af16d8231e3b4e);
$parcel$export(module.exports, "FrameSizes", () => $ee66395b0435b80e$export$f34582f4a07dd8dd);

var $4cOi8 = parcelRequire("4cOi8");
var $ekK2d = parcelRequire("ekK2d");
var $ee66395b0435b80e$export$f8af16d8231e3b4e = /*#__PURE__*/ function(NavigationStyle) {
    NavigationStyle["PROGRESS_CIRCLES"] = "progress-circles";
    NavigationStyle["THUMBNAILS"] = "thumbnails";
    return NavigationStyle;
}({});
var $ee66395b0435b80e$export$f34582f4a07dd8dd = /*#__PURE__*/ function(FrameSizes) {
    FrameSizes["NAVIGATION_THUMBNAIL"] = "navigationThumbnail";
    FrameSizes["NAVIGATION_THUMBNAIL_V2"] = "navigationThumbnailV2";
    FrameSizes["HERO"] = "hero";
    return FrameSizes;
}({});

});

parcelRegister("1Assz", function(module, exports) {

$parcel$export(module.exports, "carouselNewParametersV2", () => $ea7f503ab44e3724$export$3882df2b635374e2);
$parcel$export(module.exports, "FRAME_V2_DEFAULT_IMAGE_SRC", () => $ea7f503ab44e3724$export$b713c3bc8c446d60);
$parcel$export(module.exports, "frameNewParametersV2", () => $ea7f503ab44e3724$export$27643bf44cc02178);
$parcel$export(module.exports, "createNewFrameWithDefaultParameters", () => $ea7f503ab44e3724$export$5d30fc17e786110);
$parcel$export(module.exports, "updateLinkAndConfluencePageId", () => $ea7f503ab44e3724$export$721510bd2cdb9b4f);
$parcel$export(module.exports, "useCarouselExtensionParametersAndActions", () => $ea7f503ab44e3724$export$3cf295eeccc933e1);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $kyKWe = parcelRequire("kyKWe");

var $bknsA = parcelRequire("bknsA");

var $dh538 = parcelRequire("dh538");

var $1VNax = parcelRequire("1VNax");
var $7q60U = parcelRequire("7q60U");
var $g3LxX = parcelRequire("g3LxX");

var $4cOi8 = parcelRequire("4cOi8");
var $ekK2d = parcelRequire("ekK2d");
var $drkRB = parcelRequire("drkRB");

var $jp2S4 = parcelRequire("jp2S4");
/** This hook has been created newly for Carousel v2 development
 * We intend to decouple Cards and Carousel extensions as much as we can,
 * as migration from Confluence to Platform will be more simple
 * Much refactoring has been done with reference to cards as frames in v2 design spec
 * Where possible, we resort to referring to cards and frames
 * However, when directly referring to param attribute, we will continue to use the naming cards and cardId
 * This is because Carousel v1 macros params will need to be mapped to the frames and frameId naming, which if can be hazardous
 */ const $ea7f503ab44e3724$var$i18n = (0, $2nPZH.defineMessages)({
    placeholderTitle: {
        id: "custom-sites-extensions.carousel.placeholder.title",
        defaultMessage: "Give your frame a title"
    },
    placeholderDescription: {
        id: "custom-sites-extensions.carousel.placeholder.description",
        defaultMessage: "Customize this frame to create a rotating carousel."
    }
});
const $ea7f503ab44e3724$export$3882df2b635374e2 = {
    cornerStyle: (0, $4cOi8.CornerStyle).ROUNDED,
    isAutoplayEnabled: false,
    navigationStyle: (0, $drkRB.NavigationStyle).THUMBNAILS
};
const $ea7f503ab44e3724$export$b713c3bc8c446d60 = 'https://images.unsplash.com/photo-1488470015861-8bb1317353ef?auto=format&fit=crop&q=80&w=1080';
const $ea7f503ab44e3724$export$27643bf44cc02178 = {
    [(0, $ekK2d.ITEM_FIELDS).BACKGROUND_COLOR]: "var(--ds-background-accent-blue-subtlest, #E9F2FF)",
    [(0, $ekK2d.ITEM_FIELDS).TEXT_COLOR]: "var(--ds-text, #172B4D)",
    [(0, $ekK2d.ITEM_FIELDS).LAYOUT]: (0, $4cOi8.CommonLayout).SPLIT_IMAGE_RIGHT,
    [(0, $ekK2d.ITEM_FIELDS).IMAGE_SRC]: $ea7f503ab44e3724$export$b713c3bc8c446d60,
    [(0, $ekK2d.ITEM_FIELDS).IMAGE_ALT_TEXT]: "Close-up of a vibrant green palm leaf\u2019s patterns.",
    buttonText: '',
    buttonStyle: (0, $4cOi8.ButtonStyle).DEFAULT
};
const $ea7f503ab44e3724$export$4f94ab8184143ae6 = {
    imageSrc: 'https://images.unsplash.com/photo-1579547621706-1a9c79d5c9f1?auto=format&fit=crop&q=80&w=1080',
    imageAltText: 'purple and pink light illustration'
};
const $ea7f503ab44e3724$export$5d30fc17e786110 = (isCarouselV2Enabled, intl, defaultField, randomLayout)=>({
        cardId: (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))(),
        link: '',
        isLinkUserEdited: false,
        title: isCarouselV2Enabled ? intl.formatMessage($ea7f503ab44e3724$var$i18n.placeholderTitle) : '',
        isTitleUserEdited: false,
        description: isCarouselV2Enabled ? intl.formatMessage($ea7f503ab44e3724$var$i18n.placeholderDescription) : '',
        isDescriptionUserEdited: false,
        ...$ea7f503ab44e3724$export$4f94ab8184143ae6,
        ...isCarouselV2Enabled && {
            ...$ea7f503ab44e3724$export$27643bf44cc02178,
            ...randomLayout && {
                [(0, $ekK2d.ITEM_FIELDS).LAYOUT]: randomLayout
            }
        },
        ...defaultField
    });
const $ea7f503ab44e3724$export$721510bd2cdb9b4f = (link, confluencePageId, isLinkUserEdited)=>{
    return {
        [(0, $ekK2d.ITEM_FIELDS).LINK]: link,
        [(0, $ekK2d.ITEM_FIELDS).CONFLUENCE_PAGE_ID]: confluencePageId || '',
        [(0, $ekK2d.ITEM_FIELDS).IS_LINK_USER_EDITED]: isLinkUserEdited || false
    };
};
const $ea7f503ab44e3724$var$fetchLocalIdMacroParameters = (editorActions, localId, isCarouselV2Enabled)=>{
    const localIdNode = editorActions?.getNodeByLocalId?.(localId)?.toJSON();
    let params = localIdNode?.attrs?.parameters;
    if (params === undefined) return undefined;
    // Make a copy of the params object to avoid mutating the original object
    params = {
        ...params
    };
    // If the extension was created prior to removal of type field, remove it from object here
    // This update is/was not done in combination with a feature gate
    delete params['type'];
    if (isCarouselV2Enabled) {
        var _params, _params1, _params2;
        params.version = (0, $jp2S4.CAROUSEL_VERSION_2);
        const { cornerStyle: cornerStyle, isAutoplayEnabled: isAutoplayEnabled, navigationStyle: navigationStyle } = $ea7f503ab44e3724$export$3882df2b635374e2;
        (_params = params).cornerStyle ?? (_params.cornerStyle = cornerStyle);
        (_params1 = params).isAutoplayEnabled ?? (_params1.isAutoplayEnabled = isAutoplayEnabled);
        (_params2 = params).navigationStyle ?? (_params2.navigationStyle = navigationStyle);
        /* construct frames array with intercepted params */ params.cards = params.cards?.map((frame)=>{
            return {
                ...$ea7f503ab44e3724$export$27643bf44cc02178,
                // override BG color back to white for v1 carousels to maintain parity...
                [(0, $ekK2d.ITEM_FIELDS).BACKGROUND_COLOR]: "var(--ds-background-input, #FFFFFF)",
                // ... but let frame BG color (if already set, eg to default color) override again
                ...(0, (/*@__PURE__*/$parcel$interopDefault($bknsA)))(frame, [
                    'imagePosition'
                ])
            };
        }) || params.cards;
        /* there were card fields added to carousel params that were nonfunctional.
     * reconstructing params to those with them omitted
     */ params = (0, (/*@__PURE__*/$parcel$interopDefault($bknsA)))(params, [
            'size',
            'isPublishDateShown',
            'isAvatarShown'
        ]);
    } else params.version = (0, $jp2S4.CAROUSEL_VERSION_1);
    return params;
};
const $ea7f503ab44e3724$var$updateFrameInList = (frames, cardId, updatedField)=>frames.map((frame)=>{
        if (frame.cardId === cardId) return {
            ...frame,
            ...updatedField
        };
        return frame;
    });
const $ea7f503ab44e3724$export$3cf295eeccc933e1 = ({ localId: localId, editorActions: editorActions })=>{
    const [carouselParameters, setCarouselParameters] = (0, $gwFzn.useState)($ea7f503ab44e3724$var$fetchLocalIdMacroParameters(editorActions, localId, (0, $dh538.fg)('company_hub_carousel_v2')));
    const usedLayoutsRef = (0, $gwFzn.useRef)(new Set());
    const lastUsedLayoutRef = (0, $gwFzn.useRef)(null);
    const { setIsInAutoFocusMode: setIsInAutoFocusMode, setSelectedToEditCardId: setSelectedToEditCardId } = (0, $g3LxX.useExtensionsActions)();
    const { cards: frames } = carouselParameters ?? {};
    const intl = (0, $dBxQj.default)();
    (0, $gwFzn.useEffect)(()=>{
        const extensionNodeParams = $ea7f503ab44e3724$var$fetchLocalIdMacroParameters(editorActions, localId, (0, $dh538.fg)('company_hub_carousel_v2'));
        setCarouselParameters(extensionNodeParams);
    }, [
        editorActions,
        localId
    ]);
    const getRandomLayout = (0, $gwFzn.useCallback)(()=>{
        const allLayouts = Object.values((0, $4cOi8.CommonLayout));
        if (usedLayoutsRef.current.size >= allLayouts.length - 1) usedLayoutsRef.current = new Set();
        const availableLayouts = allLayouts.filter((layout)=>!usedLayoutsRef.current.has(layout) && layout !== lastUsedLayoutRef.current);
        const randomIndex = Math.floor(Math.random() * availableLayouts.length);
        const randomLayout = availableLayouts[randomIndex];
        usedLayoutsRef.current.add(randomLayout);
        lastUsedLayoutRef.current = randomLayout;
        return randomLayout;
    }, []);
    const updateExtensionParams = (0, $gwFzn.useCallback)((newExtensionParameters)=>{
        setCarouselParameters((prevParams)=>{
            const updatedParams = {
                ...prevParams,
                ...newExtensionParameters
            };
            // Save params to ADF and state
            (0, $7q60U.updateNodeParameters)(editorActions, updatedParams);
            return updatedParams;
        });
    }, [
        editorActions
    ]);
    const addFrame = (0, $gwFzn.useCallback)(()=>{
        const newFrame = $ea7f503ab44e3724$export$5d30fc17e786110((0, $dh538.fg)('company_hub_carousel_v2'), intl, undefined, getRandomLayout());
        updateExtensionParams({
            cards: [
                ...(0, $1VNax.checkItems)(frames) || [],
                newFrame
            ]
        });
        setIsInAutoFocusMode(true);
        setSelectedToEditCardId(newFrame.cardId);
    }, [
        frames,
        updateExtensionParams,
        setSelectedToEditCardId,
        setIsInAutoFocusMode,
        intl,
        getRandomLayout
    ]);
    const removeFrame = (0, $gwFzn.useCallback)((cardId)=>updateExtensionParams({
            cards: frames.filter((frame)=>frame.cardId !== cardId)
        }), [
        frames,
        updateExtensionParams
    ]);
    const updateMainFormField = (0, $gwFzn.useCallback)((updatedFields)=>updateExtensionParams(updatedFields), [
        updateExtensionParams
    ]);
    const updateFrameFormField = (0, $gwFzn.useCallback)((cardId, updatedField)=>{
        const updatedFrames = $ea7f503ab44e3724$var$updateFrameInList(frames, cardId, updatedField);
        updateExtensionParams({
            cards: updatedFrames
        });
    }, [
        frames,
        updateExtensionParams
    ]);
    const carouselActions = (0, $gwFzn.useMemo)(()=>({
            addFrame: addFrame,
            removeFrame: removeFrame,
            updateMainFormField: updateMainFormField,
            updateFrameFormField: updateFrameFormField
        }), [
        addFrame,
        removeFrame,
        updateMainFormField,
        updateFrameFormField
    ]);
    return {
        carouselParameters: carouselParameters,
        carouselActions: carouselActions
    };
};

});
parcelRegister("jp2S4", function(module, exports) {

$parcel$export(module.exports, "CAROUSEL_VERSION_1", () => $7d803a017dc6143e$export$9575b4f5d97a1c29);
$parcel$export(module.exports, "CAROUSEL_VERSION_2", () => $7d803a017dc6143e$export$b429752dfe934bea);
const $7d803a017dc6143e$export$9575b4f5d97a1c29 = '1';
const $7d803a017dc6143e$export$b429752dfe934bea = '2';

});


parcelRegister("bbfkc", function(module, exports) {

$parcel$export(module.exports, "ITEM", () => $6ec678c7d9ef502a$export$25d99ac3e552cf7a);
$parcel$export(module.exports, "ALIGNMENT", () => $6ec678c7d9ef502a$export$470d0905851e47a1);
$parcel$export(module.exports, "BORDER", () => $6ec678c7d9ef502a$export$8a9179e387c60c17);
$parcel$export(module.exports, "CORNERS", () => $6ec678c7d9ef502a$export$87780c3e8dee494d);
var $6ec678c7d9ef502a$export$25d99ac3e552cf7a = /*#__PURE__*/ function(ITEM) {
    ITEM["LINK"] = "link";
    ITEM["MENU"] = "menu";
    return ITEM;
}({});
var $6ec678c7d9ef502a$export$470d0905851e47a1 = /*#__PURE__*/ function(ALIGNMENT) {
    ALIGNMENT["LEFT"] = "left";
    ALIGNMENT["CENTER"] = "center";
    ALIGNMENT["RIGHT"] = "right";
    return ALIGNMENT;
}({});
var $6ec678c7d9ef502a$export$8a9179e387c60c17 = /*#__PURE__*/ function(BORDER) {
    BORDER["NONE"] = "none";
    BORDER["ALL_SIDES"] = "all_sides";
    BORDER["BOTTOM"] = "bottom";
    return BORDER;
}({});
var $6ec678c7d9ef502a$export$87780c3e8dee494d = /*#__PURE__*/ function(CORNERS) {
    CORNERS["ROUND"] = "round";
    CORNERS["SHARP"] = "sharp";
    return CORNERS;
}({});

});

parcelRegister("62fWd", function(module, exports) {

$parcel$export(module.exports, "ForgeUIExtensionPointProvider", () => $3c9dbf4421667f34$export$64f0f7e9be5f8ff);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $jIiuI = parcelRequire("jIiuI");
var $5U2YR = parcelRequire("5U2YR");

var $3Spjc = parcelRequire("3Spjc");
const $3c9dbf4421667f34$export$64f0f7e9be5f8ff = ({ analyticsWebClient: analyticsWebClient, environment: environment, product: product, page: page, children: children })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $jIiuI.EnvironmentContext).Provider, {
        value: environment,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5U2YR.MetricsContextProvider), {
            value: {
                product: product,
                page: page
            },
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3Spjc.default), {
                client: analyticsWebClient,
                commonAttributes: {
                    moduleType: page
                },
                children: children
            })
        })
    });
};

});

var $930b6a6ae5de1be7$exports = {};

(parcelRequire("fzRTW")).register(new URL("", import.meta.url).toString(), JSON.parse("[\"fpf26\",\"CommentEditor.19b85423.js\",\"2pYvv\",\"LinkCardsExtension.f1c03fd3.js\",\"bSMGI\",\"modal.a92001a3.js\",\"i4cia\",\"component-lazy.574d1e74.js\",\"ffEVr\",\"vendors~editor_icon.abe6f96e.js\",\"kDqHr\",\"file-icon.c15bd8a8.js\",\"4HZlX\",\"chart-bar-icon.aef1455e.js\",\"7jSfd\",\"list-bullet-icon.2167b4bd.js\",\"kjZZD\",\"vendors~editor_icon-object.e97fc136.js\",\"ffEVr\",\"vendors~editor_icon.abe6f96e.js\",\"8Sd4b\",\"component-lazy.1e066a38.js\",\"koKgZ\",\"datasourceRenderFailedAnalyticsWrapper.9fbf001d.js\",\"7ixUU\",\"datasourceTableView.6296a0cb.js\",\"91C8u\",\"refresh.8e489499.js\",\"aHE9G\",\"vendors~editor_atlaskit.8ae77fed.js\",\"joJy8\",\"vendors~editor_atlaskit.runtime.57e9b3c7.js\",\"aZinD\",\"vendors.9b56afad.js\",\"c6MKV\",\"stable_vendors.135a4db0.js\",\"5EeCg\",\"modal.cb062983.js\",\"7fMGd\",\"dark.16cc06e7.svg\",\"8OP1c\",\"light.e350f7db.svg\",\"gywm1\",\"dark.981334ac.svg\",\"29by2\",\"light.d61b1f64.svg\",\"XXMwE\",\"dark.90199792.svg\",\"cqbvn\",\"light.5ffcf568.svg\",\"bEo2Z\",\"standard.6c3cc6ed.svg\",\"eGv20\",\"modal.98cc933d.js\",\"6cVEd\",\"fire-event.32c1479b.js\",\"iPuyw\",\"ReadTimePopup.904f443c.js\",\"gxkhQ\",\"ReadTimePopup.runtime.fbfd7b53.js\",\"4iW5M\",\"modal.8d32217b.js\",\"gasnx\",\"modal.runtime.bf8b8cba.js\",\"gxkhQ\",\"ReadTimePopup.runtime.fbfd7b53.js\",\"gasnx\",\"modal.runtime.bf8b8cba.js\",\"5Pnad\",\"cs.956703b3.js\",\"3qzeo\",\"da.a6e51006.js\",\"4UYlu\",\"de.0e52901f.js\",\"3qbnQ\",\"en.c857dc06.js\",\"HY4Vc\",\"en_GB.8088c875.js\",\"fJQPR\",\"en_ZZ.67fbfeed.js\",\"gxipV\",\"es.69f016fd.js\",\"3uZ1q\",\"et.ac1a0ae0.js\",\"ardvv\",\"fi.be067ec8.js\",\"cjhdF\",\"fr.498beda1.js\",\"2mWUI\",\"hu.c32b69d9.js\",\"29Sce\",\"is.02c33977.js\",\"dBvXj\",\"it.fbe42f1a.js\",\"gmdLX\",\"ja.3923bf19.js\",\"fcXn9\",\"ko.419acfa2.js\",\"lH0NU\",\"nb.082125cc.js\",\"3OEsN\",\"nl.7ba79509.js\",\"hGLdi\",\"pl.d68b8afc.js\",\"Xi5AP\",\"pt_BR.ea61b74c.js\",\"f7XHA\",\"pt_PT.e565d94b.js\",\"14AZs\",\"ro.699a99b7.js\",\"lsFbX\",\"ru.1a33c100.js\",\"ibz6c\",\"sk.b538319e.js\",\"7I8FK\",\"sv.e3c6634e.js\",\"l7PQP\",\"th.93fb5ab5.js\",\"4iSRl\",\"tr.0b957c49.js\",\"fLjHM\",\"uk.7a8159bb.js\",\"3YGga\",\"vi.a291c6ef.js\",\"7yGIa\",\"zh_TW.018b8e11.js\",\"dZksg\",\"zh.be550b65.js\",\"2lsX7\",\"main.1b7a934b.js\",\"1S9KM\",\"lock-locked--lock-circle.11c51b01.js\",\"bL008\",\"lock-circle.fdb473df.js\",\"jcdL6\",\"action.0a8137c7.js\",\"8SMhH\",\"code.d6b8067d.js\",\"bxYOE\",\"date.03e54c47.js\",\"f0zmS\",\"decision.b0f74b53.js\",\"ggLwo\",\"divider.ee99e8cc.js\",\"1p2DU\",\"emoji.e542ebd5.js\",\"1RKLZ\",\"images.50557af0.js\",\"7i9aD\",\"layout.896ff24e.js\",\"4VRIj\",\"link.4c2afa22.js\",\"djSOz\",\"list-number.87b71c46.js\",\"irpaz\",\"list.eaa0868a.js\",\"3SeOO\",\"mention.9cfda511.js\",\"5se79\",\"panel-error.62057b3d.js\",\"9bXCA\",\"panel-note.59120c9e.js\",\"1WrE2\",\"panel-success.58f0ef3b.js\",\"fnpAC\",\"panel-warning.cacb4e29.js\",\"gMSS1\",\"panel.e9156a35.js\",\"e1MXN\",\"quote.b63af4e1.js\",\"4dn8m\",\"status.1d7beedc.js\",\"9E19j\",\"one-column-layout.7347bd62.js\",\"bDOK7\",\"two-column-layout.d12f3568.js\",\"jhuLr\",\"three-column-layout.08b99461.js\",\"gMvtj\",\"four-column-layout.5a85aae9.js\",\"7unhY\",\"five-column-layout.78208ad9.js\",\"aKgoC\",\"heading1.146cf77d.js\",\"9ygQy\",\"heading2.db1ef0b8.js\",\"kTaDo\",\"heading3.d5d438f3.js\",\"d2kuO\",\"heading4.4c9e1386.js\",\"6wLYX\",\"heading5.bfeb0683.js\",\"eVKfF\",\"heading6.7fd49ad3.js\",\"b4NwV\",\"feedback.7c2aec31.js\",\"h9aqE\",\"expand.183cbdea.js\",\"jXrdN\",\"datasource-jira-issue.ed2ea567.js\",\"9Bneg\",\"datasource-assets-objects.57e99865.js\",\"1lXr0\",\"datasource-confluence-search.7f39cb19.js\",\"bHGMG\",\"loom.6ed25479.js\",\"aA6N2\",\"Toolbar.7104bf70.js\",\"iPz8n\",\"GlobalFeedbackCollector.429b0000.js\",\"1RolH\",\"EmojiPickerComponent.54ab340a.js\",\"etwBB\",\"activity.d3402161.js\",\"a2rZD\",\"custom.fc3cd725.js\",\"ePm95\",\"flags.40431f78.js\",\"kJcWg\",\"food.473b199a.js\",\"cUIjD\",\"frequent.67753c39.js\",\"4tIwu\",\"nature.96f73db7.js\",\"1sEV4\",\"objects.ee88e397.js\",\"6Tafs\",\"people.9a055314.js\",\"6j8nK\",\"symbols.fdc6ed64.js\",\"i1sL7\",\"travel.5460db1e.js\",\"36ctu\",\"productivity.bb738ebf.js\",\"bEnB5\",\"modal.74fde4f3.js\",\"fhU7k\",\"esm.50a6c5c3.js\",\"4hOv8\",\"esm.bc27d7ff.js\",\"joJy8\",\"vendors~editor_atlaskit.runtime.57e9b3c7.js\",\"iAspJ\",\"CommentEditor.39c848ae.js\",\"g6DP5\",\"date.0a55edc8.js\",\"iHkQk\",\"date.runtime.e1f72400.js\",\"8HprW\",\"modal.c82b72a8.js\",\"6aruy\",\"media-client-react.88ecf091.js\",\"fsZ6i\",\"media-client-react.c0fe67d6.js\",\"7VwsU\",\"media-client-react.runtime.3c7d023a.js\",\"jWyan\",\"angle-brackets-icon.0108617d.js\",\"7VwsU\",\"media-client-react.runtime.3c7d023a.js\",\"4M7W5\",\"mediaInlineCard.76880eb0.js\",\"jDjSj\",\"16.8a4cce0e.js\",\"8059b\",\"16.afe6487f.js\",\"hPalR\",\"16.93dce164.js\",\"2fk6g\",\"16.bea78523.js\",\"dil5i\",\"24.e2acaae5.js\",\"4GfT7\",\"modal.a6702a0e.js\",\"iP5Bv\",\"mediaInlineAnalyticsErrorBoundary.7700cc82.js\",\"fwuXj\",\"cardWithMediaClient.434c822c.js\",\"8Ozg8\",\"inlinePlayer.7538d68b.js\",\"cXPC0\",\"EmbedModal.a727c385.js\",\"dUKeO\",\"vid-full-screen-on.89bfbdcb.js\",\"iiqDR\",\"vid-full-screen-off.edfa2cde.js\",\"5rLJa\",\"vid-pause.69823d28.js\",\"6dDCB\",\"outgoing-sound.2de86a1c.js\",\"h9Mrx\",\"video.a6ea4b90.js\",\"8DoxJ\",\"modal.3fd9f746.js\",\"8LPnw\",\"lock-locked--lock-filled.17f891f6.js\",\"P5iE2\",\"24.874d8c90.js\",\"42vdC\",\"24.8676303a.js\",\"9Bu2S\",\"24.1eba1b1c.js\",\"8pE8S\",\"24.4b97cbb2.js\",\"ivQYH\",\"24.272a2b94.js\",\"7a9CL\",\"24.f46d75b2.js\",\"8mzoy\",\"24.b3fbae03.js\",\"bjzRn\",\"24.95103356.js\",\"fYi1a\",\"24.8dbe60cd.js\",\"fqrMn\",\"24.a62bdaeb.js\",\"hzK1f\",\"24.98083536.js\",\"e53Dv\",\"vid-play.9e8ddef6.js\",\"6gqpV\",\"GlobalFeedbackCollector.493c1808.js\",\"7Vmxp\",\"table.f8779bf1.js\",\"cKkZK\",\"media-viewer-error-boundary.b1b2c520.js\",\"bHwQq\",\"archive.fd275619.js\",\"9vSeI\",\"audio.7b721c3b.js\",\"8PuzS\",\"archive.ece53d4b.js\",\"lixGB\",\"78-EUC-H.51d0c3f9.js\",\"fH2pk\",\"78-EUC-V.64ff1cfd.js\",\"kZB45\",\"78-H.0ed13b16.js\",\"6BxSI\",\"78-RKSJ-H.dc86b34e.js\",\"i9zPw\",\"78-RKSJ-V.82830549.js\",\"8Qq8X\",\"78-V.b650b3b6.js\",\"hUHQJ\",\"78ms-RKSJ-H.8d99de38.js\",\"4Y4SR\",\"78ms-RKSJ-V.d9f17393.js\",\"axQaS\",\"83pv-RKSJ-H.f8767ab6.js\",\"hh6Ks\",\"90ms-RKSJ-H.d832d6a6.js\",\"gyPUO\",\"90ms-RKSJ-V.260dbffb.js\",\"aduQJ\",\"90msp-RKSJ-H.364f2808.js\",\"3iFld\",\"90msp-RKSJ-V.aa85de80.js\",\"6XUCn\",\"90pv-RKSJ-H.848d9bac.js\",\"8eJG6\",\"90pv-RKSJ-V.92513b15.js\",\"iveJ5\",\"Add-H.729159c7.js\",\"kOqxj\",\"Add-RKSJ-H.2baf4c23.js\",\"1zYOj\",\"Add-RKSJ-V.24c188d0.js\",\"2MU2T\",\"Add-V.f276585e.js\",\"oH9eX\",\"Adobe-CNS1-0.c94fb46d.js\",\"fSa6m\",\"Adobe-CNS1-1.22c8a053.js\",\"g2oEO\",\"Adobe-CNS1-2.b6e41c65.js\",\"8WzHR\",\"Adobe-CNS1-3.6168987e.js\",\"ca0bh\",\"Adobe-CNS1-4.44238a8c.js\",\"cfcpu\",\"Adobe-CNS1-5.62d26997.js\",\"li5lK\",\"Adobe-CNS1-6.7ebee211.js\",\"kujwR\",\"Adobe-CNS1-UCS2.0dd5c8ce.js\",\"8iFzj\",\"Adobe-GB1-0.249f5de6.js\",\"6D5co\",\"Adobe-GB1-1.74dabbbf.js\",\"cfFSd\",\"Adobe-GB1-2.4a68d0c8.js\",\"exff1\",\"Adobe-GB1-3.b5b05f5d.js\",\"aeuVs\",\"Adobe-GB1-4.c9dd9584.js\",\"aLrjO\",\"Adobe-GB1-5.0e92a2eb.js\",\"j3PYN\",\"Adobe-GB1-UCS2.bb70ebea.js\",\"d0uYO\",\"Adobe-Japan1-0.4d890a6e.js\",\"eEcvV\",\"Adobe-Japan1-1.a0781bed.js\",\"820v9\",\"Adobe-Japan1-2.9f2dc797.js\",\"frVgA\",\"Adobe-Japan1-3.15951cff.js\",\"jdQzX\",\"Adobe-Japan1-4.0cfae895.js\",\"Z8yoS\",\"Adobe-Japan1-5.66dd1b5b.js\",\"k2vqy\",\"Adobe-Japan1-6.7e06fceb.js\",\"kgt4y\",\"Adobe-Japan1-UCS2.e121ba74.js\",\"eP0RM\",\"Adobe-Korea1-0.ab6029ff.js\",\"gA5f7\",\"Adobe-Korea1-1.f58d7af7.js\",\"i4Ed8\",\"Adobe-Korea1-2.90e46d21.js\",\"l6X7m\",\"Adobe-Korea1-UCS2.37651d5b.js\",\"aphLF\",\"B5-H.35e26a2d.js\",\"7EoeH\",\"B5-V.af3f0204.js\",\"6Q7ZY\",\"B5pc-H.e4f1d7a8.js\",\"8cnq9\",\"B5pc-V.8f5377c3.js\",\"7NcV5\",\"CNS-EUC-H.6bb831b5.js\",\"cxpt9\",\"CNS-EUC-V.8c378414.js\",\"l27ve\",\"CNS1-H.ea7d046f.js\",\"c6rCW\",\"CNS1-V.1fdf3e4e.js\",\"3upsV\",\"CNS2-H.705fd9e8.js\",\"k9G9k\",\"CNS2-V.c55f4d63.js\",\"bDgpL\",\"ETHK-B5-H.7f8e45d5.js\",\"33eqd\",\"ETHK-B5-V.09bf3c22.js\",\"5F3PA\",\"ETen-B5-H.05fb1408.js\",\"hfiT2\",\"ETen-B5-V.5e380c42.js\",\"jMuj8\",\"ETenms-B5-H.3891364b.js\",\"gNTCu\",\"ETenms-B5-V.394705ca.js\",\"6rTQb\",\"EUC-H.b991c232.js\",\"l89SH\",\"EUC-V.0ac4677e.js\",\"iEkij\",\"Ext-H.5968bae5.js\",\"eVVKx\",\"Ext-RKSJ-H.d9938a5e.js\",\"kL3q4\",\"Ext-RKSJ-V.e9a51cbe.js\",\"avDfo\",\"Ext-V.74d1f996.js\",\"l3LgN\",\"GB-EUC-H.910bba6d.js\",\"eIBS8\",\"GB-EUC-V.0c6edfac.js\",\"8HXb3\",\"GB-H.92bed904.js\",\"lWK2A\",\"GB-V.4564569a.js\",\"iYIwI\",\"GBK-EUC-H.f5f68a8f.js\",\"g4Lp1\",\"GBK-EUC-V.97682197.js\",\"9jlRI\",\"GBK2K-H.edc4a051.js\",\"g2IgM\",\"GBK2K-V.46c62554.js\",\"24SBU\",\"GBKp-EUC-H.da565c58.js\",\"gzU5W\",\"GBKp-EUC-V.d5927fe2.js\",\"jN4tb\",\"GBT-EUC-H.267ac8c0.js\",\"6fVUl\",\"GBT-EUC-V.7720b25f.js\",\"e0AMV\",\"GBT-H.974fe797.js\",\"htjXf\",\"GBT-V.12defd7a.js\",\"hWeIU\",\"GBTpc-EUC-H.43d524d7.js\",\"1eaMl\",\"GBTpc-EUC-V.c77ba0fc.js\",\"fDvqM\",\"GBpc-EUC-H.08408830.js\",\"2de5A\",\"GBpc-EUC-V.ddbe12a3.js\",\"19tEv\",\"H.8a76eaa0.js\",\"j0hRA\",\"HKdla-B5-H.e6a4bedb.js\",\"fd9qd\",\"HKdla-B5-V.94816590.js\",\"e9cdN\",\"HKdlb-B5-H.41238054.js\",\"aNHZK\",\"HKdlb-B5-V.c7a56f0d.js\",\"hgC4a\",\"HKgccs-B5-H.423aefeb.js\",\"eEaBv\",\"HKgccs-B5-V.fff775c8.js\",\"fYV0G\",\"HKm314-B5-H.60d4b9bb.js\",\"dJs80\",\"HKm314-B5-V.997bace9.js\",\"4Y1kq\",\"HKm471-B5-H.0a6f2053.js\",\"hYpsA\",\"HKm471-B5-V.5588cb3b.js\",\"9xkOt\",\"HKscs-B5-H.cbf6db19.js\",\"lm69C\",\"HKscs-B5-V.cf9a31dc.js\",\"kva4v\",\"Hankaku.ca0ba78b.js\",\"5AfTB\",\"Hiragana.85378b4a.js\",\"3TaY6\",\"KSC-EUC-H.aff5022e.js\",\"8wf7j\",\"KSC-EUC-V.3949c72d.js\",\"cgHyF\",\"KSC-H.4ed431c9.js\",\"cxq0E\",\"KSC-Johab-H.22d6dfec.js\",\"ipw37\",\"KSC-Johab-V.0ee59f70.js\",\"aD76K\",\"KSC-V.dc2b8859.js\",\"8okaY\",\"KSCms-UHC-H.b54f6070.js\",\"i7fxp\",\"KSCms-UHC-HW-H.998acbf6.js\",\"7fYMC\",\"KSCms-UHC-HW-V.0a3c59db.js\",\"imOx6\",\"KSCms-UHC-V.37c6be44.js\",\"gKF8I\",\"KSCpc-EUC-H.4cfc83d8.js\",\"9m5PS\",\"KSCpc-EUC-V.5881e143.js\",\"8asvD\",\"Katakana.321c2f5f.js\",\"7HkN3\",\"NWP-H.6a69fa60.js\",\"isnju\",\"NWP-V.88613bd5.js\",\"f31m2\",\"RKSJ-H.2af2abd8.js\",\"2VYvR\",\"RKSJ-V.65a07798.js\",\"1KF3Q\",\"Roman.ca13d8f3.js\",\"29QIq\",\"UniCNS-UCS2-H.f2596cac.js\",\"dVqyh\",\"UniCNS-UCS2-V.4be9430a.js\",\"7UKDA\",\"UniCNS-UTF16-H.bb71adc5.js\",\"Q9KG4\",\"UniCNS-UTF16-V.d89c4950.js\",\"c2z6B\",\"UniCNS-UTF32-H.6ef36f87.js\",\"lTznr\",\"UniCNS-UTF32-V.c838593e.js\",\"7t7V6\",\"UniCNS-UTF8-H.77d5771f.js\",\"lcMXU\",\"UniCNS-UTF8-V.70a7ba9f.js\",\"4Y11P\",\"UniGB-UCS2-H.1303e3c8.js\",\"6MnqR\",\"UniGB-UCS2-V.c4668ab1.js\",\"eQt1R\",\"UniGB-UTF16-H.d1be3be2.js\",\"fm8Lw\",\"UniGB-UTF16-V.a072ba07.js\",\"4l8L7\",\"UniGB-UTF32-H.e2d1c79f.js\",\"1tDis\",\"UniGB-UTF32-V.76c200be.js\",\"2Vv5T\",\"UniGB-UTF8-H.41f4baba.js\",\"iWa77\",\"UniGB-UTF8-V.8ed42052.js\",\"38Eab\",\"UniJIS-UCS2-H.e0c99f94.js\",\"lDeVy\",\"UniJIS-UCS2-HW-H.2086623a.js\",\"8aWy7\",\"UniJIS-UCS2-HW-V.ffb2caeb.js\",\"76QHL\",\"UniJIS-UCS2-V.21ffe4a5.js\",\"lRW10\",\"UniJIS-UTF16-H.4216604d.js\",\"aJpvy\",\"UniJIS-UTF16-V.48b4e738.js\",\"7s6rx\",\"UniJIS-UTF32-H.038159ea.js\",\"jUs4H\",\"UniJIS-UTF32-V.34681c47.js\",\"a8YIF\",\"UniJIS-UTF8-H.3f187918.js\",\"fH9Jk\",\"UniJIS-UTF8-V.dd6be6a0.js\",\"13MuZ\",\"UniJIS2004-UTF16-H.c4a60299.js\",\"hwfXT\",\"UniJIS2004-UTF16-V.2dbaf4f4.js\",\"dGSeC\",\"UniJIS2004-UTF32-H.dba66596.js\",\"9rrYA\",\"UniJIS2004-UTF32-V.74761cad.js\",\"7d1OI\",\"UniJIS2004-UTF8-H.4ec8549f.js\",\"809oM\",\"UniJIS2004-UTF8-V.c5cc5b20.js\",\"bdrR8\",\"UniJISPro-UCS2-HW-V.4031e777.js\",\"4D2EW\",\"UniJISPro-UCS2-V.5072efde.js\",\"cdY8a\",\"UniJISPro-UTF8-V.7adee45d.js\",\"avqzB\",\"UniJISX0213-UTF32-H.56363b94.js\",\"j845q\",\"UniJISX0213-UTF32-V.6e415ebf.js\",\"emImx\",\"UniJISX02132004-UTF32-H.80a3d411.js\",\"f6AOW\",\"UniJISX02132004-UTF32-V.75e044a9.js\",\"7pSug\",\"UniKS-UCS2-H.4ff5f169.js\",\"465mT\",\"UniKS-UCS2-V.af99e23d.js\",\"3w6Hd\",\"UniKS-UTF16-H.b031c3f9.js\",\"4T3rW\",\"UniKS-UTF16-V.dbaec3f8.js\",\"d8Hqs\",\"UniKS-UTF32-H.11f34035.js\",\"77ADK\",\"UniKS-UTF32-V.344d4ef0.js\",\"dkDCu\",\"UniKS-UTF8-H.a4bf67c4.js\",\"8Qdf7\",\"UniKS-UTF8-V.af9521f3.js\",\"bhNwf\",\"V.5ce814bb.js\",\"ioEN1\",\"WP-Symbol.9e3226a6.js\",\"edP6u\",\"home.9c6d2e67.js\",\"2OhRQ\",\"codeViewerRenderer.29c899a3.js\",\"3wpjh\",\"image.4dcab477.js\",\"869mA\",\"video.f359eb55.js\",\"j7Vtd\",\"audio.b8a5bcaa.js\",\"f33Ay\",\"doc.c719a94c.js\",\"2JEgu\",\"codeViewer.50fd71a1.js\",\"93dCk\",\"codeViewer.71b6c0bb.js\",\"01BDc\",\"dist.f36f7d00.js\",\"jneCP\",\"dist.adf4c603.js\",\"7sleH\",\"dist.21a5cb52.js\",\"3lBx7\",\"dist.82105929.js\",\"1EgQg\",\"dist.7c7ec582.js\",\"iWiJK\",\"dist.03768f8e.js\",\"gkT8b\",\"dist.11d30e66.js\",\"lLY5F\",\"dist.521fa1db.js\",\"7BCTg\",\"dist.daadd8cb.js\",\"jD4Pj\",\"dist.0c350558.js\",\"217bQ\",\"dist.563e7eec.js\",\"3AIgh\",\"dist.a75fea7a.js\",\"3WBDc\",\"dist.b344a93f.js\",\"gnPOt\",\"dist.761f9dfc.js\",\"73p2H\",\"dist.0397e21f.js\",\"22pEl\",\"dist.8b39c40c.js\",\"cgrQ3\",\"dist.a04ab887.js\",\"5BOC6\",\"dist.30663d49.js\",\"b3fvV\",\"dist.37416658.js\",\"ajqM4\",\"dist.9ab582a8.js\",\"jjPUS\",\"apl.b81e50f9.js\",\"h9FOd\",\"asciiarmor.8042d41d.js\",\"aCljb\",\"asn1.a9aaf8f7.js\",\"lE1F7\",\"asterisk.f4595367.js\",\"aXFnX\",\"brainfuck.4bd8ce2f.js\",\"gkO56\",\"cobol.30d0d372.js\",\"aXQyM\",\"clike.34bb1d46.js\",\"diAFJ\",\"clojure.21077391.js\",\"d7yTx\",\"css.3d1ff96e.js\",\"b2YDT\",\"cmake.0e3e455b.js\",\"4ga7U\",\"coffeescript.c2281a85.js\",\"cZ3D7\",\"commonlisp.97a06575.js\",\"qaaCs\",\"cypher.b80fd281.js\",\"9Fcz0\",\"python.f5111821.js\",\"6RZjl\",\"crystal.a0197265.js\",\"ji1Kk\",\"d.42c2683e.js\",\"2L5Mz\",\"diff.cdb11d67.js\",\"lmz4e\",\"dockerfile.70f43558.js\",\"814bh\",\"dtd.11778cc2.js\",\"7XVNh\",\"dylan.468e767f.js\",\"hGS6V\",\"ebnf.30d80091.js\",\"592ir\",\"ecl.5a273c1a.js\",\"hPiIc\",\"eiffel.85a912d8.js\",\"7wfVk\",\"elm.77c03e04.js\",\"ebMo8\",\"erlang.6dc9b335.js\",\"5h0BU\",\"sql.83903d9f.js\",\"bE4uu\",\"factor.91d4bca2.js\",\"7Mgt2\",\"fcl.8ab4c522.js\",\"bOI1J\",\"forth.3c528cb4.js\",\"bmWQh\",\"fortran.e0029ed4.js\",\"kHxTh\",\"mllike.153cf519.js\",\"6MC1n\",\"gas.a7bccbc7.js\",\"lNBbh\",\"gherkin.3957c5fc.js\",\"bYMjO\",\"groovy.2c7c6877.js\",\"kIBZl\",\"haskell.27501ac4.js\",\"3uMSv\",\"haxe.54a5898e.js\",\"9vuGq\",\"http.bc2057b4.js\",\"1eHix\",\"idl.b9661b63.js\",\"7kn4A\",\"javascript.398b6ea8.js\",\"j4qEZ\",\"jinja2.a602283d.js\",\"3ozoR\",\"julia.eb339e67.js\",\"3DTzS\",\"livescript.a061dc12.js\",\"hURlP\",\"lua.1771bd2a.js\",\"2gQjS\",\"mirc.df514b63.js\",\"hoU9b\",\"mathematica.4b8aab4c.js\",\"40pAI\",\"modelica.f8eb4cea.js\",\"i5YKF\",\"mumps.cf82c6f0.js\",\"hIeWi\",\"mbox.e4169567.js\",\"8q3KK\",\"nginx.5d266b03.js\",\"1VXLT\",\"nsis.e4e191fa.js\",\"bAq00\",\"ntriples.12b53fef.js\",\"aEtpl\",\"octave.05b71169.js\",\"hfTKk\",\"oz.0938f362.js\",\"hTqBJ\",\"pascal.39d89476.js\",\"5ukWe\",\"perl.52765d5b.js\",\"3XLd5\",\"pig.0fb008c2.js\",\"2QavN\",\"powershell.f53ac67c.js\",\"ch01A\",\"properties.ff60ea69.js\",\"7inaT\",\"protobuf.c983d409.js\",\"cJ7mc\",\"pug.9abece4a.js\",\"5NvMz\",\"puppet.b9ab89df.js\",\"ego66\",\"q.aaa15180.js\",\"hj2Rh\",\"r.0b08b779.js\",\"b7tzx\",\"rpm.685318b2.js\",\"3YkAH\",\"ruby.04bb2af8.js\",\"cf92i\",\"sas.9ff0311d.js\",\"8W2eu\",\"scheme.a36ef94c.js\",\"lcrbq\",\"shell.d5f15f17.js\",\"98Pr8\",\"sieve.f0f2cb2c.js\",\"9dDWH\",\"smalltalk.33729233.js\",\"lrUqt\",\"solr.21ea773c.js\",\"bfOqz\",\"sparql.554ff633.js\",\"glXdM\",\"spreadsheet.cd8b4101.js\",\"b9USS\",\"stylus.7e0a4e39.js\",\"kPthK\",\"swift.633d1fa8.js\",\"jsCJL\",\"stex.8d5212f6.js\",\"abYjx\",\"verilog.d22265d7.js\",\"d7Hao\",\"tcl.ced1f258.js\",\"axn6R\",\"textile.51355a0b.js\",\"jDwZc\",\"tiddlywiki.5e83d78f.js\",\"ejPOn\",\"tiki.6fb365f5.js\",\"jx5LN\",\"toml.84dc3c91.js\",\"lsrGy\",\"troff.f7dd2860.js\",\"caKW9\",\"ttcn.4a33ec37.js\",\"6cyuP\",\"ttcn-cfg.5ae2f58f.js\",\"kezEf\",\"turtle.ed16c466.js\",\"ec2k9\",\"webidl.32e06ad6.js\",\"gQivI\",\"vb.278bc558.js\",\"1MGG6\",\"vbscript.a342aecd.js\",\"19BgE\",\"velocity.40adbcac.js\",\"4QVhK\",\"vhdl.7cdb96b8.js\",\"5PTeQ\",\"xquery.27819ab6.js\",\"7rV3v\",\"yacas.6d63ee7e.js\",\"lzeGI\",\"z80.2e6d4d2e.js\",\"jZHIh\",\"mscgen.5ea5176c.js\",\"hLKFT\",\"dist.a9b48aa5.js\",\"4ZwHa\",\"dist.83c91e9c.js\",\"gQYJt\",\"svg.0f44db18.js\",\"1qUWs\",\"media-viewer-error-boundary.445b2080.js\",\"gFHfi\",\"zoom-out.db09cd7a.js\",\"4uhcp\",\"zoom-in.5852ad10.js\",\"doomh\",\"chevron-left-circle.db11b726.js\",\"iHkQk\",\"date.runtime.e1f72400.js\",\"5WLpx\",\"ElementBrowser.24caaeb5.js\",\"64Goy\",\"modal.863c77b1.js\",\"k1740\",\"board.e21ca1d1.js\",\"2jsRt\",\"checkbox.12ed1287.js\",\"aQp8v\",\"radio.24323b5b.js\",\"gOlh9\",\"chevron-up.044d5e4d.js\",\"kO0mz\",\"audio-icon.3fb3ee2d.js\",\"gQLjx\",\"angle-brackets-icon.8e8a0f88.js\",\"3wmvj\",\"16.b741d755.js\",\"5i5pX\",\"folder-icon.fc4f6d1b.js\",\"eA5B3\",\"image-icon.79d204dd.js\",\"7AsyI\",\"video-icon.661d0519.js\",\"huUvS\",\"16.ec1fe873.js\",\"1oiJ6\",\"16.b49b338d.js\",\"lxiFd\",\"16.80951c67.js\",\"eDqo1\",\"16.f4617b7e.js\",\"6HBYC\",\"16.64a21052.js\",\"bYxCZ\",\"16.aa8224a8.js\",\"eTBsW\",\"16.fd6383aa.js\",\"020xd\",\"16.f33a251e.js\",\"ls0Um\",\"16.0d741008.js\",\"eVYW1\",\"16.fd806601.js\",\"f35QR\",\"16.b6568c92.js\",\"4sSyn\",\"24.e4066b09.js\",\"dnrR3\",\"24.9b235136.js\",\"gxkp2\",\"24.2f405197.js\",\"hiqrg\",\"24.ee437072.js\",\"490Jr\",\"24.b65ff1b2.js\",\"ggkqU\",\"24.9110597b.js\",\"65smn\",\"24.c0e41410.js\",\"1fh7t\",\"24.f65169ea.js\",\"4mLGd\",\"24.c47a3404.js\",\"cMlHc\",\"24.9330c41f.js\",\"lSzlP\",\"24.1bb21f19.js\",\"5erPe\",\"24.d6e6663a.js\",\"cXodu\",\"24.4e0ad70d.js\",\"4j0Ap\",\"confluence-icon.394c835e.js\",\"87j6O\",\"jira-icon.eb7336b7.js\",\"3vYMs\",\"attachment.7777c63a.js\",\"8PsNg\",\"attachment.bdae94e9.js\",\"9UmxH\",\"task.44180bef.js\",\"d1W0Z\",\"task.dc5b3230.js\",\"hlgZa\",\"component.7f613fb8.js\",\"aQnhg\",\"component.a0c10401.js\",\"jSJrn\",\"eye-open--watch.54d1d960.js\",\"jaTPo\",\"watch.5c4b5bd8.js\",\"kgJcP\",\"thumbs-up--like.0d91b8c9.js\",\"dkV2T\",\"like.fba99a44.js\",\"513ba\",\"arrow-up.8164df13.js\",\"kefuj\",\"priority-blocker.d8096123.js\",\"bWqqo\",\"priority-critical.c242bf7a.js\",\"9ZeC1\",\"priority-high.3eb9ac43.js\",\"9zpNb\",\"priority-highest.0e78632a.js\",\"gOpe6\",\"priority-low.21ac1cc4.js\",\"RAL03\",\"priority-lowest.535dc7b3.js\",\"5nQIT\",\"priority-major.94eb9450.js\",\"l9frT\",\"priority-medium.3a2d978a.js\",\"lACXG\",\"priority-minor.d2ac136e.js\",\"ao5oO\",\"priority-trivial.965f2280.js\",\"7owaE\",\"question-circle--question.6cca022c.js\",\"eWzXf\",\"question.2ebb5e70.js\",\"9PQvE\",\"angle-brackets--code.229a6e25.js\",\"9DPul\",\"code.6512be9f.js\",\"9dfxa\",\"subtasks--subtask.85d82f30.js\",\"hl2oi\",\"subtask.c893ffae.js\",\"3wY4G\",\"goal-icon.c8c90c26.js\",\"88r9N\",\"projects-icon.c26711c5.js\",\"cqZpg\",\"manual-triggers-modal.819600d5.js\",\"aoU9B\",\"RelatedLinksModal.f210ab13.js\",\"kDLrp\",\"EmbedModal.d1a84bf4.js\",\"lRAA1\",\"LinkCards.347897e8.js\",\"4hycL\",\"NoResults.9d75157a.svg\",\"lciST\",\"RestrictedContent.b8a54c0d.svg\",\"5nZdp\",\"LinkCards.a56bdafe.js\",\"iOWBI\",\"LinkCards.ae54363b.js\",\"8dyWu\",\"CardMacroIcon.550a1caf.js\"]"));


//# sourceMappingURL=CommentEditor.19b85423.js.map
